module.exports = __webpack_public_path__ + "83c32d57b8256fb3a1fe204adb67981f.svg";